import builder from '../builder';
import AccountingBills1 from '../../streamline-icons/bold/accounting-bills-1.svg';

export default builder('IconAccountingBills1Bold', AccountingBills1);
